import { render, staticRenderFns } from "./CustomAutocomplete.vue?vue&type=template&id=871ad596"
import script from "./CustomAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports